import { Outlet, useLocation } from 'react-router-dom';
import { Layout } from 'antd';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { ClippyAssistant } from '@components/shared/ClippyAssistant';
import { useAppSelector } from '@store/hooks';
import { useTheme } from '@hooks/useTheme';

const { Content } = Layout;

/**
 * Newsletter Studio routes where the content needs every available pixel
 * (the Monthly Create / Edit screen runs ChatPanel + PreviewPanel side
 * by side; the Sent Newsletters page hosts a long table). On those
 * routes we collapse the Content padding from the default 24 down to
 * ``12px 24px`` — same horizontal margin so the Sidebar gutter
 * doesn't shift, but ~24 px less top/bottom chrome.
 */
const COMPACT_PATH_RE = /^\/newsletters\/(monthly\/(create|edit)|sent)/;

export function AppLayout() {
  const collapsed = useAppSelector((state) => state.app.sidebarCollapsed);
  const { isDark } = useTheme();
  const { pathname } = useLocation();

  const siderWidth = collapsed ? 72 : 260;
  const compact = COMPACT_PATH_RE.test(pathname);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sidebar />
      <Layout style={{ marginLeft: siderWidth, transition: 'margin-left 0.2s' }}>
        <Header />
        <Content
          style={{
            padding: compact ? '12px 24px' : 24,
            minHeight: 'calc(100vh - 64px)',
            background: isDark ? '#0f172a' : '#f1f5f9',
          }}
        >
          <Outlet />
        </Content>
      </Layout>
      <ClippyAssistant />
    </Layout>
  );
}
